import { applyMiddleware, compose, createStore  } from 'redux'
import { responsiveStoreEnhancer } from 'redux-responsive'
import thunkMiddleware from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'react-router-redux'
import getRootReducer from '../reducers'

export const history = createHistory()

export default function configureStore(preloadedState, additionalReducers) {

    const rootReducer = getRootReducer(additionalReducers)

    const store = createStore(
        rootReducer,
        preloadedState,
        compose(
            responsiveStoreEnhancer,
            applyMiddleware(
                thunkMiddleware,
                routerMiddleware(history)
            ),
            window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
        )
    )

    if (module.hot) {
        module.hot.accept('../reducers', () => {
            const nextReducer = require('../reducers').default
            store.replaceReducer(nextReducer)
        })
    }

    return store

}



// WEBPACK FOOTER //
// src/store/index.js